module.exports = __webpack_public_path__ + "img/search.bef7701f.svg";